import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import type { TAvailableTag } from '@onesource/schemas';
import type { FC } from 'react';

interface SelectedTagChipsProps {
  tags: TAvailableTag[];
  onRemove: (tag: TAvailableTag) => void;
}

/**
 * The tags picked in the composer / edit form, rendered as removable chips
 * below the editor. Soft primary tint to read as "selected", matching the
 * feed's active filter chips.
 */
export const SelectedTagChips: FC<SelectedTagChipsProps> = ({ tags, onRemove }) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
      {tags.map(tag => (
        <Chip
          key={`${tag.type}:${tag.value}`}
          size="small"
          label={tag.label}
          onDelete={() => onRemove(tag)}
          sx={{
            '@keyframes chipIn': {
              from: { opacity: 0, transform: 'scale(0.9)' },
              to: { opacity: 1, transform: 'scale(1)' },
            },
            animation: 'chipIn 0.15s ease-out',
            height: 24,
            borderRadius: '8px',
            bgcolor: theme => `${theme.palette.primary.main}14`,
            color: 'primary.main',
            fontFamily: 'Figtree, sans-serif',
            fontSize: 12,
            fontWeight: 600,
            '& .MuiChip-label': { px: '8px' },
            '& .MuiChip-deleteIcon': {
              fontSize: 15,
              color: theme => `${theme.palette.primary.main}99`,
              '&:hover': { color: 'primary.main' },
            },
          }}
        />
      ))}
    </Box>
  );
};
